import { takeLatest, call, put } from 'redux-saga/effects';
import { FORM_ERROR } from 'final-form';
import { OK } from 'http-status-codes';

import { types, actions } from './duck';
import { sendContactMessage } from './api';
import { safeResolveAsync } from '../../utils/saga';

export function* sendContactMessageSaga({ payload, resolve }) {
  try {
    yield put(actions.sendContactMessageRequest());
    const response = yield call(sendContactMessage, payload);

    if (response.status === OK && response.data && response.data.success) {
      yield put(actions.sendContactMessageSuccess());
      yield call(safeResolveAsync, resolve);
    } else {
      const errorMessage =
        (response.data && response.data.error) || response.data || response.status;

      yield put(actions.sendContactMessageFailure(errorMessage));
      yield call(safeResolveAsync, resolve, { [FORM_ERROR]: errorMessage });
    }
  } catch (error) {
    yield put(actions.sendContactMessageFailure(error.message));
    yield call(safeResolveAsync, resolve, { [FORM_ERROR]: error.message });
  }
}

export default function* saga() {
  yield takeLatest(types.SEND_CONTACT_MESSAGE, sendContactMessageSaga);
}